module.exports = __webpack_public_path__ + "media/images/home/cover-mobile@3x-6dc8e1b041450a5a42a90ef07df5fb63.jpg";